import { useAzureAuth } from "@datamole/wds-azure-auth";

import { useAppDispatch, useAppSelector } from "@/store";
import { logout } from "@/store/slices/auth.slice";

export const useLogout = () => {
    const dispatch = useAppDispatch();
    const { authStrategy } = useAppSelector((state) => {
        return state.auth;
    });
    const { triggerLogout: logoutAzureAd } = useAzureAuth();

    const handleLogout = () => {
        // Initiate Azure AD logout if the user is authenticated via Entra ID
        if (authStrategy === "entraId") {
            logoutAzureAd();
        }
        // Clean up Redux auth state
        dispatch(logout());
    };

    return handleLogout;
};
